// Section 3 and 26: the new-game form: presets above the detailed options.
import { catalog, defaultOptions, type DifficultyPreset, type NewGameOptions } from '../sim/api';

export interface NewGameFormVM {
  presets: { id: DifficultyPreset; options: NewGameOptions }[];
  populationPresets: readonly number[];
  populationMin: number;
  populationMax: number;
  defaults: NewGameOptions;
}

export function newGameFormVM(): NewGameFormVM {
  const c = catalog();
  return {
    presets: (Object.keys(c.presets) as DifficultyPreset[]).map((id) => ({
      id,
      options: { ...c.presets[id], seed: '' },
    })),
    populationPresets: c.populationPresets,
    populationMin: c.populationMin,
    populationMax: c.populationMax,
    defaults: defaultOptions(''),
  };
}
